import { thousandSeparated } from 'shared/util/formatting';
import type { Filters, MapConfig, SearchConfig } from '@/interfaces';
import { trackMapClick } from '@/utils/tracking/finnAnalytics';
import { updateSearchResultsPageQueryParams } from '@/utils/url/routerHelpers';

export interface TopBarProps {
    numberOfHotels: number;
    setMapState: (config: MapConfig) => void;
    filtersOpen: boolean;
    setFiltersOpen: (filtersOpen: boolean) => void;
    filters: Filters;
    searchConfig: SearchConfig;
}

export const TopBarMap = ({ numberOfHotels, setMapState, filtersOpen, setFiltersOpen, filters, searchConfig }: TopBarProps) => (
    <div className="flex flex-row flex-align-center flex-justify-space-between map-top-bar u-ph8">
        <button
            type="button"
            data-testid="closeMapButton"
            className="button button--small button--utility top-bar-button"
            onClick={() => {
                setMapState({ open: false, selectedHotel: {} });
                updateSearchResultsPageQueryParams(false, filters, searchConfig);
                trackMapClick(false);
            }}>
            <i className="icon icon--cross-mini u-mr8" />
            Lukk kart
        </button>
        <output data-testid="resultCount">
            <span className="u-strong">{numberOfHotels ? thousandSeparated(numberOfHotels) : '0'}</span> hoteller
        </output>
        <button
            type="button"
            className="button button--small button--utility top-bar-button"
            onClick={() => setFiltersOpen(!filtersOpen)}
            data-testid="showFilterButton">
            {filtersOpen ? 'Lukk filter' : 'Vis filter'}
        </button>
    </div>
);
